/**
 * Country picker, from the API's list.
 *
 * A list rather than free text: hand-typed values were producing "india",
 * "India" and "IN" for the same country. The stored value is the ISO code.
 */
import { useConfig } from "../store/config";

interface Props {
  id?: string;
  value: string;
  onChange: (code: string) => void;
  /** Shown when nothing is selected. */
  placeholder?: string;
}

export function CountrySelect({ id = "country", value, onChange, placeholder }: Props) {
  const countries = useConfig((state) => state.config.countries);

  return (
    <select id={id} value={value} onChange={(event) => onChange(event.target.value)}>
      <option value="">{placeholder ?? "Select your country"}</option>
      {countries.map((country) => (
        <option key={country.code} value={country.code}>
          {country.name}
        </option>
      ))}
    </select>
  );
}
